/*
 * @Author: 牛字杰 niuzijie@.jtexpress
 * @Date: 2022-07-13 14:28:15
 * @LastEditors: niuzijie
 * @LastEditTime: 2025-03-26 17:12:50
 * @FilePath: \yl-wxcx-coupon-front\src\router\routerMobile.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const routes = [
  {
    path: '/welfare',
    name: 'Welfare',
    component: () => import(/* webpackChunkName: "about" */ '../views/welfare/welfareMobile.vue'),
    meta: { title: '电商卖家限时福利！' },
  },
  {
    path: '/coupon',
    name: 'Coupon',
    component: () => import(/* webpackChunkName: "about" */ '../views/coupon/index.vue'),
  },
  {
    path: '/grabSuccess',
    name: 'GrabSuccess',
    component: () => import(/* webpackChunkName: "about" */ '../views/coupon/grabSuccess.vue'),
  },
  {
    path: '/menerima',
    name: 'Menerima',
    component: () => import(/* webpackChunkName: "about" */ '../views/coupon/menerima.vue'),
  },
  {
    path: '/surpriseImg',
    name: 'surpriseImg',
    component: () => import(/* webpackChunkName: "about" */ '../views/surpriseImg.vue'),
  },
  {
    path: '/Xmas',
    name: 'xmas',
    component: () => import(/* webpackChunkName: "about" */ '../views/xmas'),
    meta: { title: '极兔欢乐送大挑战' },
  },
  {
    path: '/pullNew',
    name: 'pullNew',
    component: () => import(/* webpackChunkName: "about" */ '../views/pullNew'),
    meta: { title: '大客户拉新活动' },
  },
  {
    path: '/pullNew2',
    name: 'pullNew2',
    component: () => import(/* webpackChunkName: "about" */ '../views/pullNew2'),
    meta: { title: '大客户拉新活动' },
  },
  {
    path: '/JTPullNew',
    name: 'JTPullNew',
    component: () => import(/* webpackChunkName: "about" */ '../views/JTPullNew/index.vue'),
    meta: { title: '大客户拉新活动' },
  },
  // {
  //   path: '*',
  //   redirect:{path:"/"}
  // },
]

export default routes
